import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { register } from "@shopify/theme-sections";

register("product_slider", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination]);

    var prodswiper = new Swiper(".productSwiper", {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".product-button-next",
        prevEl: ".product-button-prev",
      },
    });

    // SwiperCore.use([Navigation, Pagination]);
    // var productSwiper = new Swiper(".swiper-container-product", {
    //   loop: false,
    //   resistance: true,
    //   resistanceRatio: 0,
    //   slidesPerView: 6,
    //   freeMode: false,
    //   slidesPerGroup: 1,
    //   // centeredSlides: false,
    //   // watchOverflow: true,
    //   navigation: {
    //     nextEl: ".product-button-next",
    //     prevEl: ".product-button-prev",
    //   },
    //   breakpoints: {
    //     587: {
    //       slidesPerView: 3,
    //     },
    //     1200: {
    //       slidesPerView: 4,
    //     },
    //     1400: {
    //       slidesPerView: 5,
    //     },
    //   },
    // });
    // productSwiper;

    document.querySelectorAll(".product-wrapper-item").forEach((item) => {
      let gridItem = item;

      let gridItemOpen = gridItem.querySelector(".toggle-product-carousel");
      let gridItemClose = gridItem.querySelector(
        ".toggle-product-carousel-close"
      );
      let quickAddContent = gridItem.querySelector(".toggle-content");

      if (gridItemOpen) {
        gridItemOpen.addEventListener("click", (e) => {
          e.preventDefault();
          quickAddContent.classList.toggle("toggle-content-is-visible");
        });

        gridItemClose.addEventListener("click", (e) => {
          e.preventDefault();
          quickAddContent.classList.toggle("toggle-content-is-visible");
        });
      }
    });

    // document.querySelectorAll(".product-wrapper-item").forEach((item) => {
    //   var wrapper = item.querySelector(".toggle-product-carousel");
    //   var quantityWrapper = item.querySelector(".toggle-content");
    //   var quantityWrapperClose = item.querySelector(
    //     ".toggle-product-carousel-close"
    //   );
    //   wrapper.addEventListener("click", () => {
    //     quantityWrapper.classList.toggle("toggle-content-is-visible");
    //   });
    //   quantityWrapperClose.addEventListener("click", () => {
    //     quantityWrapper.classList.remove("toggle-content-is-visible");
    //   });
    // });
  },
});
